module.exports = __webpack_public_path__ + "img/minjiang1.b48db0c9.png";